import { createSlice } from '@reduxjs/toolkit';
import type { PremisesResponse } from 'api/models/TAddress';
import type { NormalizedError } from 'errors/types';
import type { RootState } from 'state/store';

type AddressListState = {
  isLoading: boolean;
  errors: null | NormalizedError[];
  data: PremisesResponse;
};

export const initialState: AddressListState = {
  isLoading: false,
  errors: null,
  data: {}
};

export const slice = createSlice({
  name: 'addressList',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.isLoading = initialState.isLoading;
      state.errors = initialState.errors;
      state.data = initialState.data;
    },
    setIsLoading: (state) => {
      state.isLoading = true;
    },
    setSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.data = payload;
      state.errors = initialState.errors;
    },
    setAddressList: (state, { payload }) => {
      state.data.addresses = payload;
    },
    setError: (state, { payload }) => {
      state.isLoading = false;
      state.data = {};
      state.errors = payload;
    }
  }
});

export const {
  setIsLoading,
  setSuccess,
  setError,
  setInitialState,
  setAddressList
} = slice.actions;

export const selectSlice = (state: RootState) => state[slice.name];
export const selectAddressListData = (state: RootState) =>
  selectSlice(state).data;
export const selectAddressList = (state: RootState) =>
  selectAddressListData(state).addresses;
export const selectIsLoading = (state: RootState) =>
  selectSlice(state).isLoading;
export const selectErrors = (state: RootState) => selectSlice(state).errors;
export default slice.reducer;
